export default __webpack_public_path__ + "static/media/x-box-image-detail-2.7a56a5c5.png";